module.exports = __webpack_public_path__ + "static/reasonone-logo-022d7cce01487caeffa45af21dc7881c.png";